/**
 * Anlege-Wunsch aus Ablage › „Neue wiederkehrende Aufgabe".
 *
 * MainLayout öffnet die Seite und hinterlegt den Wunsch hier; die Seite löst ihn
 * ein, sobald sie aktiv ist. Ein Merker statt eines Query-Parameters, weil
 * `TabContent` den Pfad exakt auf `/recurring` prüft.
 */
let pending = false
const listeners = new Set<() => void>()

export function requestRecurringCreate(): void {
  pending = true
  listeners.forEach(listener => listener())
}

/** `true`, wenn ein Wunsch offen war — danach ist er verbraucht. */
export function consumeRecurringCreateRequest(): boolean {
  const had = pending
  pending = false
  return had
}

export function subscribeRecurringCreateRequest(listener: () => void): () => void {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}
